import React, { useState } from 'react';
import { useParams } from 'react-router-dom';


import AppBar from '@material-ui/core/AppBar';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { useAuth } from '../../../hooks/auth';
import TabPanel from './TabPanel';
import DeliveryFee from './tabs/DeliveryFee';
import Grade from './tabs/Grade';
import ImportacaoProdutos from './tabs/ImportacaoProdutos';
import Layout from './tabs/Layout';
import Parametros from './tabs/Parameters';
import Usuario from './tabs/Usuario';
import Integrations from './tabs/Integrations';
import Fiscal from './tabs/Fiscal';

// New tab
import Endereco from '../../../newPages/Endereco';
import Loja from '../../../newPages/Loja';
import Funcionarios from '../../../newPages/Funcionarios';
import FormOfPayment from '../../../newPages/FormOfPayment';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const tabNumberAba = {
  0: 'loja',
  1: 'endereco',
  2: 'layout',
  3: 'usuario',
  4: 'funcionarios',
  5: 'formas_de_pagamento',
  6: 'taxas_de_entrega',
  7: 'grade',
  8: 'parametros',
  9: 'importacao_de_produtos',
};

const TabBar: React.FC = () => {
  let { tab } = useParams<any>();
  const { findRotinas } = useAuth();

  const classes = useStyles();
  const [value, setValue] = useState(() => {
    while (Number(tab) <= 9) {
      if (
        findRotinas(
          tabNumberAba[tab as 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9] as string,
        )?.listar
      ) {
        return Number(tab);
      }
      ++tab;
    }
    return 10;
  });

  const handleChange = (_: React.ChangeEvent<{}>, newValue: number): void => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="config_tabs"
        >
          <Tab
            label="Loja"
            disabled={!findRotinas('loja').listar}
            {...a11yProps(0)}
          />
          <Tab
            label="Endereço"
            disabled={!findRotinas('endereco').listar}
            {...a11yProps(1)}
          />
          <Tab
            label="Layout"
            disabled={!findRotinas('layout').listar}
            {...a11yProps(2)}
          />
          <Tab
            label="Usuário"
            disabled={!findRotinas('usuario').listar}
            {...a11yProps(3)}
          />
          <Tab
            label="Funcionários"
            disabled={!findRotinas('funcionarios').listar}
            {...a11yProps(4)}
          />
          <Tab
            label="Formas de Pagamento"
            disabled={!findRotinas('formas_de_pagamento').listar}
            {...a11yProps(5)}
          />
          <Tab
            label="Taxas de Entrega"
            disabled={!findRotinas('taxas_de_entrega').listar}
            {...a11yProps(6)}
          />
          <Tab
            label="Grade"
            disabled={!findRotinas('grade').listar}
            {...a11yProps(7)}
          />
          <Tab
            label="Parâmetros"
            disabled={!findRotinas('parametros').listar}
            {...a11yProps(8)}
          />
          <Tab
            label="Importação de Produtos"
            disabled={!findRotinas('importacao_de_produtos').listar}
            {...a11yProps(9)}
          />
          <Tab label="Integrações" {...a11yProps(10)} />
          <Tab label="Fiscal" {...a11yProps(11)} />
        </Tabs>
      </AppBar>

      <TabPanel
        value={value}
        index={0}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Loja />
      </TabPanel>

      <TabPanel
        value={value}
        index={1}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Endereco />
      </TabPanel>

      <TabPanel
        index={2}
        value={value}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Layout />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <Usuario />
      </TabPanel>

      <TabPanel
        value={value}
        index={4}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Funcionarios />
      </TabPanel>

      <TabPanel
        value={value}
        index={5}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <FormOfPayment />
      </TabPanel>

      <TabPanel value={value} index={6}>
        <DeliveryFee />
      </TabPanel>

      <TabPanel
        value={value}
        index={7}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Grade />
      </TabPanel>

      <TabPanel
        value={value}
        index={8}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Parametros />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <ImportacaoProdutos />
      </TabPanel>

      <TabPanel
        value={value}
        index={10}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Integrations />
      </TabPanel>

      <TabPanel
        value={value}
        index={11}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Fiscal />
      </TabPanel>
    </div>
  );
};

export default TabBar;
